import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoldingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
			style: {},
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M60.4,92c0.1,0,0.2,0,0.4-0.1c0.2-0.1,0.4-0.4,0.4-0.6V79.1c0-1.8,1.1-3.9,2.4-4.7 c0,0,3.7-2.1,3.7-2.1l6.7-3.9c0,0,0,0,0,0c2-1.2,3.9-3.3,5.4-5.9c1.6-2.9,2.4-6,2.4-8.9V31.8c0-0.3-0.1-0.5-0.4-0.6l-41.5-24 c-0.2-0.1-0.5-0.1-0.7,0c-0.2,0.1-0.4,0.4-0.4,0.6v21.8c0,5.2-3.2,11.3-7,13.6c0,0,0,0,0,0l-10.4,6c-0.8,0.5-1.6,1.3-2.2,2.4 c-0.6,1.1-1,2.4-1,3.6v12.1c0,0.3,0.1,0.5,0.4,0.6l41.5,24C60.2,91.9,60.3,92,60.4,92z"
			})
		}) }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M81.7,30.6l-41.5-24c-0.4-0.2-0.9-0.2-1.3,0c-0.4,0.2-0.7,0.7-0.7,1.1v21.8c0,5-3,10.9-6.7,13.1 l-10.4,6c-0.9,0.5-1.8,1.5-2.4,2.6c-0.7,1.2-1,2.6-1,3.8v12.1c0,0.5,0.3,0.9,0.7,1.1l41.5,24c0.2,0.1,0.4,0.2,0.7,0.2 s0.5-0.1,0.7-0.2c0.4-0.2,0.7-0.7,0.7-1.1V79.1c0-1.6,1-3.5,2.1-4.2l10.3-6c0,0,0,0,0.1,0c2.1-1.2,4.1-3.4,5.6-6.1 c1.6-3,2.5-6.2,2.5-9.2V31.7C82.4,31.3,82.1,30.8,81.7,30.6z M62.8,72.5L62,72c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.5 c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.2,0.2,0.5,0.5,0.6l0.2,0.1c-0.9,1-1.5,2.3-1.9,3.6l-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.1 c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.2,0.2,0.5,0.5,0.6l0.8,0.5V89L20.2,66.5v-9.2c0.4,0.2,1,0,1.2-0.4 c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.5-0.5-0.6l-0.8-0.5c0-0.8,0.3-1.7,0.7-2.5c0.3-0.5,0.6-0.9,0.9-1.2l0.8,0.4 c0.4,0.3,1.1,0.1,1.3-0.4c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.5l8.8-5.1l0.8,0.5c0.4,0.3,1.1,0.1,1.3-0.4 c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.5-0.4-0.6l0,0c3.8-3.1,6.6-9.1,6.6-14.3V10.1l38.9,22.4v21c0,2.5-0.8,5.4-2.2,7.9 c-1.2,2.2-2.7,3.9-4.3,5L72.4,66c-0.5-0.3-1-0.1-1.3,0.4C71,66.6,71,66.8,71,67.1c0.1,0.2,0.2,0.4,0.3,0.5L62.8,72.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M58.5,70L55,68c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C58.9,70.4,58.7,70.1,58.5,70z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M48.8,71.4l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C49.2,71.7,49.1,71.5,48.8,71.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M55.8,75.3l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C56.2,75.7,56,75.5,55.8,75.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M50.7,55.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 c-0.1-0.2-0.2-0.5-0.4-0.6l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7 C50.3,55.3,50.4,55.5,50.7,55.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M69,64l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.4,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C69.4,64.3,69.2,64.1,69,64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M62,60l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.4,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C62.4,60.3,62.3,60.1,62,60z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M36.8,47.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 c-0.1-0.2-0.2-0.5-0.4-0.6l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7 C36.4,47.3,36.5,47.5,36.8,47.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M43.7,51.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 c-0.1-0.2-0.2-0.5-0.4-0.6l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7 C43.3,51.3,43.5,51.5,43.7,51.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M51.9,67.3c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.5-0.5-0.6L48,64c-0.2-0.1-0.5-0.2-0.7-0.1 c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1 C51.4,67.8,51.7,67.6,51.9,67.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M44.9,63.4c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.5-0.5-0.6l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1 c-0.2,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1 C44.4,63.8,44.7,63.7,44.9,63.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M30.9,55.4c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.5-0.5-0.6l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1 c-0.2,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1 C30.4,55.9,30.7,55.7,30.9,55.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M37.9,59.4c0.1-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.2-0.5-0.5-0.6l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1 c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1 C37.4,59.9,37.7,59.7,37.9,59.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M28,59.5l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C28.4,59.8,28.2,59.6,28,59.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M41.9,67.4l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.5C37,66,37,66.3,37,66.5 c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C42.3,67.8,42.1,67.5,41.9,67.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M35,63.5l-3.5-2c-0.2-0.1-0.5-0.2-0.7-0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.2,0.5,0.5,0.6l3.5,2c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.8-0.5c0.1-0.2,0.2-0.5,0.1-0.7 C35.3,63.8,35.2,63.6,35,63.5z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M42.5,29.9l-1.7-1c-0.6-0.3-1.3-0.1-1.6,0.4c-0.3,0.6-0.1,1.3,0.4,1.6l1.7,1 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C43.3,31,43.1,30.2,42.5,29.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M55.9,37.6l-3.3-1.9c-0.6-0.3-1.3-0.1-1.6,0.4c-0.3,0.6-0.1,1.3,0.4,1.6l3.3,1.9 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C56.7,38.7,56.5,38,55.9,37.6z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M49.2,33.8l-3.3-1.9c-0.6-0.3-1.3-0.1-1.6,0.4c-0.3,0.6-0.1,1.3,0.4,1.6l3.3,1.9 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C50,34.8,49.8,34.1,49.2,33.8z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M62.6,41.5l-3.3-1.9c-0.3-0.2-0.6-0.2-0.9-0.1c-0.3,0.1-0.6,0.3-0.7,0.6c-0.3,0.6-0.1,1.3,0.4,1.6 l3.3,1.9c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C63.4,42.6,63.2,41.8,62.6,41.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M69.3,45.4L66,43.4c-0.6-0.3-1.3-0.1-1.6,0.4c-0.3,0.6-0.1,1.3,0.4,1.6l3.3,1.9 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C70.1,46.4,69.9,45.7,69.3,45.4z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M76,49.2l-3.3-1.9c-0.6-0.3-1.3-0.1-1.6,0.4c-0.3,0.6-0.1,1.3,0.4,1.6l3.3,1.9 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C76.8,50.3,76.6,49.6,76,49.2z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M81,52.1l-1.7-1C79.1,51,78.7,51,78.4,51c-0.3,0.1-0.6,0.3-0.7,0.6c-0.3,0.6-0.1,1.3,0.4,1.6 l1.7,1c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6C81.8,53.2,81.6,52.5,81,52.1z"
			})
		] })
	] }) })
});
export default SvgFoldingSm;
